<ion-app>
    <lh-header-menu *ngIf="menuFlag" [menuData]="menuData"></lh-header-menu>
    <ion-router-outlet id="mainContent"></ion-router-outlet>
</ion-app>
